import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";


export class BankSelectorViewModel extends SelectorBaseViewModel<bank>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-888D848B-1D22-4E4F-A12A-713BD514372E";
    }

    protected async loadData(): Promise<bank[]> {
        let result =await ServerConnection.callServer('/Complex/FinancialServices/GetAllBank',{})
        return result.Bank.map(x=>{
            let r = new bank(this);
            r.id = x.Id;
            r.title = x.Name;
            return r;
        });
    }
}

export class bank extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}